module.exports = __webpack_public_path__ + "media/images/right-e0bdc0c55c7b7f52c5618e5e7ae47310.svg";